package exception

class CannotReadFileException : Throwable()
